export default __webpack_public_path__ + "static/media/bound_bleu_logo.2d4efa71.png";